import React, { createContext } from 'react';
import { BankDataWithPointName } from './types';

export interface BankContextInterface {
  bankData: BankDataWithPointName;
}

const BankContext = createContext<BankContextInterface | undefined>(undefined);

interface Props {
  children: React.ReactNode;
  bankData: BankDataWithPointName;
}

export const BankProvider = ({ children, bankData }: Props) => {
  return (
    <BankContext.Provider value={{ bankData }}>{children}</BankContext.Provider>
  );
};

export default BankContext;
